module.exports = __webpack_public_path__ + "img/article-2-2.29653901.jpg";